// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container_3bSG9","batchTable":"List_batchTable_1eu3R","detail":"List_detail_kQO0j"};